__turbopack_context__.v({
  "actions": "pxMy6G_actions",
  "actions2": "pxMy6G_actions2",
  "body": "pxMy6G_body",
  "bottom": "pxMy6G_bottom",
  "button": "pxMy6G_button",
  "desktopHeader": "pxMy6G_desktopHeader",
  "desktopHeadercolor_transparent": "pxMy6G_desktopHeadercolor_transparent",
  "desktopHeadercolor_white": "pxMy6G_desktopHeadercolor_white",
  "divider": "pxMy6G_divider",
  "fb": "pxMy6G_fb",
  "features": "pxMy6G_features",
  "hamburgerIcon": "pxMy6G_hamburgerIcon",
  "ig": "pxMy6G_ig",
  "img__dvDxu": "pxMy6G_img__dvDxu",
  "img__mneaK": "pxMy6G_img__mneaK",
  "img__oSjo3": "pxMy6G_img__oSjo3",
  "img__pKpQ7": "pxMy6G_img__pKpQ7",
  "img__rhiFu": "pxMy6G_img__rhiFu",
  "img__s9WzT": "pxMy6G_img__s9WzT",
  "img__zRi8V": "pxMy6G_img__zRi8V",
  "li": "pxMy6G_li",
  "logInButton": "pxMy6G_logInButton",
  "logInButton2": "pxMy6G_logInButton2",
  "logInLink": "pxMy6G_logInLink",
  "logo": "pxMy6G_logo",
  "logo3": "pxMy6G_logo3",
  "menu": "pxMy6G_menu",
  "mobileDrawer": "pxMy6G_mobileDrawer",
  "mobileDrawerItem": "pxMy6G_mobileDrawerItem",
  "mobileHeader2": "pxMy6G_mobileHeader2",
  "mobileHeader2color_transparent": "pxMy6G_mobileHeader2color_transparent",
  "mobileHeader2color_white": "pxMy6G_mobileHeader2color_white",
  "nav": "pxMy6G_nav",
  "navWrapper": "pxMy6G_navWrapper",
  "requestDemoButton": "pxMy6G_requestDemoButton",
  "requestDemoButton2": "pxMy6G_requestDemoButton2",
  "right2": "pxMy6G_right2",
  "root": "pxMy6G_root",
  "rootcolor_transparent": "pxMy6G_rootcolor_transparent",
  "rootcolor_white": "pxMy6G_rootcolor_white",
  "socials": "pxMy6G_socials",
  "svg___7CAku": "pxMy6G_svg___7CAku",
  "svg__gMWgt": "pxMy6G_svg__gMWgt",
  "svg__ifUa5": "pxMy6G_svg__ifUa5",
  "svg__moabT": "pxMy6G_svg__moabT",
  "svg__oZiqu": "pxMy6G_svg__oZiqu",
  "svg__ooQ3Y": "pxMy6G_svg__ooQ3Y",
  "svg__vEySk": "pxMy6G_svg__vEySk",
  "svg__yronw": "pxMy6G_svg__yronw",
  "text__aprEt": "pxMy6G_text__aprEt",
  "text__hHXu6": "pxMy6G_text__hHXu6",
  "text__jsmib": "pxMy6G_text__jsmib",
  "text__sduxe": "pxMy6G_text__sduxe",
  "th": "pxMy6G_th",
  "wrapper": "pxMy6G_wrapper",
  "x": "pxMy6G_x",
});
